<template>
  <div id="formulation_qa_table">
    <div class="vx-row">

      <div class="vx-col w-full">

        <b class="mt-4" v-if="!product_catalogue_info.documentation">No data available</b>

        <!--            <div v-else class="vx-row">-->
        <!--              <div class="vx-col w-full md:w-1/3 mt-8">-->
        <!--                <vx-input-group>-->
        <!--                  <template slot="prepend">-->
        <!--                    <div class="prepend-text bg-primary">-->
        <!--                      <span>Pack Size</span>-->
        <!--                    </div>-->
        <!--                  </template>-->
        <!--                  <vs-input style="font-weight: bolder" readonly :value="product_catalogue_info.pack_size" />-->
        <!--                </vx-input-group>-->
        <!--              </div>-->
        <!--              <div class="vx-col w-full md:w-1/3 mt-8">-->
        <!--                <vx-input-group>-->
        <!--                  <template slot="prepend">-->
        <!--                    <div class="prepend-text bg-primary">-->
        <!--                      <span>Unit Sold In</span>-->
        <!--                    </div>-->
        <!--                  </template>-->
        <!--                  <vs-input style="font-weight: bolder" readonly :value="product_catalogue_info.unit_sold_in" />-->
        <!--                </vx-input-group>-->
        <!--              </div>-->
        <!--            </div>-->

        <div class="vx-row my-4">
          <div class="vx-col w-full md:w-1/3 mt-4">
            <small class="label">SDS Documents</small>
            <br>
            <span v-for="(doc, index_sds) in product_catalogue_info.sds_documents" :key="index_sds">
                  <a :href="doc.file" target="_blank">{{ __nameSplitter(doc.file) }}</a> <br>
            </span>
          </div>
          <div class="vx-col w-full md:w-1/3 mt-4" v-for="(doc, doc_index) in product_catalogue_info.documentation"
               :key="doc_index">
            <small class="label">{{ doc.name }}</small>
            <br>
            <span v-for="(file, index_file) in doc.files" :key="index_file">
                  <a :href="file" target="_blank">{{ __nameSplitter(file) }}</a> <br>
                </span>
          </div>
        </div>

        <div class="vx-row" v-if="$canAll(formulationPermissions)">
          <div class="vx-col w-full">
            <vs-button @click="onClickFileUpload()" class="float-right" color="warning" size="small" type="filled">
              Add/Update Documents
            </vs-button>
          </div>
        </div>


      </div>
    </div>
    <update-product-catalogue-pop-up v-bind:product_catalogue_info="product_catalogue_info"
                                     ref="updateProductCataloguePopUp"/>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const FormulationsRepository = RepositoryFactory.get('formulations')
import UpdateProductCataloguePopUp
  from "@/components/popups/formulations/product-catalogue/UpdateProductCataloguePopUp";

export default {
  name: "FormulationProductCatalogueTab",
  components: {
    UpdateProductCataloguePopUp
  },
  data() {
    return {
      formulationId: this.formulationId,
      formulation: null,
      qa_comments: [],
      product_catalogue_info: {}
    }
  },
  props: {
    formulationPermissions: {
      type: Array,
      default: [],
    }
  },
  methods: {
    async refreshData() {
      await this.loadFormulations()
    },
    async loadFormulations() {
      await this.$vs.loading()
      const {data} = await FormulationsRepository.details(this.formulationId)
      this.formulation = data.data
      if(this.formulation.documents) {
      this.product_catalogue_info = this.formulation.documents
      } else {
        this.product_catalogue_info = {
          sds_documents: [],
          documentation: []
        }
      }
      this.$vs.loading.close()
    },
    onClickFileUpload() {
      this.$refs.updateProductCataloguePopUp.openPopup(this.formulationId)
    }
  },
  async mounted() {
    this.formulationId = this.$route.params.id
    await this.loadFormulations()
  },
  mixins: [SuccessMessage, ErrorMessages]
}
</script>

<style scoped>

.__table-heading-small {
  font-size: x-small;
  font-weight: normal;
}

</style>
